import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css'
import {BrowserRouter} from 'react-router-dom'
import { Provider } from 'react-redux';
import store from './Components/redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <BrowserRouter>
    <Provider store={store}>
    <App />
    </Provider>
    </BrowserRouter>

);


